import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import FileUpload from 'src/components/ui/FileUpload';
import { FileShape } from 'src/components/ui/FileUpload/FileUpload';

const UploadField = (props) => {
	const { label, helperText, error, value, onChange } = props;

	const inputNode = <FileUpload value={value} onChange={onChange} />;

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				{inputNode}
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{error?.length && <FormHelperText error>{error}</FormHelperText>}
			</FormControl>
		</Stack>
	);
};

UploadField.propTypes = {
	label: PropTypes.string,
	helperText: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	value: PropTypes.arrayOf(PropTypes.shape(FileShape)),
	onChange: PropTypes.func,
};

export default UploadField;
